import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState,
} from './clubs.action';
import { Club } from './clubs.model';

export interface ClubRecordsState {
    listData: any[];
    singleData: Club;
    loading: boolean;
    error: any;
}

export const initialState: ClubRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
};


export const clubRecordReducer = createReducer(
    initialState,
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
);